/**
 * Who this deployment belongs to.
 *
 * The console is whitelabel, so no screen may name us. Page titles were the
 * one place that still did: four of them shipped "— Master da Web" as a string
 * literal, and the app-wide default carried it as a fallback, so a reseller's
 * browser tab announced our brand on their own domain.
 *
 * `NUXT_PUBLIC_BRAND_NAME` is the ONE variable that answers this — the same one
 * the logo's alt text has always read. Unset degrades to a generic product
 * name, never to a brand baked into the prebuilt image: "no brand configured"
 * must not read as ours.
 *
 * (The API and the Super Admin Console spell the same idea `COMPANY_NAME`. It
 * is deliberately NOT read here as well: two names for one value in one app is
 * one of them to forget in production, and this one is already provisioned
 * everywhere.)
 */
export function useBranding() {
  const config = useRuntimeConfig()
  const { t } = useI18n()

  const brandName = computed(() => {
    const brand = String(config.public.brandName ?? '').trim()
    return brand || t('common.appName')
  })

  /**
   * A page title, branded. `undefined` is the site root — the brand alone,
   * never "undefined — Brand".
   */
  const pageTitle = (title?: string | null) =>
    title ? `${title} — ${brandName.value}` : brandName.value

  return { brandName, pageTitle }
}
